import clsx from "clsx";
import { ReactNode } from "react";

type Props = {
  className?: string;
  children: ReactNode;
};

export const WeatherTableData = ({ className, children }: Props) => {
  return <td className={clsx("text-center border-r-[1px] border-r-[#adb5bd] py-[8px]", className)}>{children}</td>;
};
